import { render, staticRenderFns } from "./visitorDialog.vue?vue&type=template&id=bb137612&scoped=true"
import script from "./visitorDialog.vue?vue&type=script&lang=js"
export * from "./visitorDialog.vue?vue&type=script&lang=js"
import style0 from "./visitorDialog.vue?vue&type=style&index=0&id=bb137612&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb137612",
  null
  
)

export default component.exports